window.angular.module('MyHippoProducer.Components').component('cart', {
    templateUrl: 'components/cart/cart.html',
    transclude: true,
    controllerAs: 'cart',
    controller: function (PolicyService) {
        this.PolicyService = PolicyService;
    }
});
